<template>
  <AppDatePickerArrows
    v-model="date"
    :min-date="minDate"
    :start-week-on="startWeekOn"
    :start-date="startDate"
    :end-date="endDate"
  >
    <AppDateRangePicker
      class="min-w-30rem"
      :start-date="startDate"
      :end-date="endDate"
      :min-date="minDate"
      :start-week-on="startWeekOn"
      :current-zone="currentZone"
      :date-limit="dateLimit"
      compute-biweekly-exclusion
      compute-monthly-exclusion
      @change="onChange"
    />
  </AppDatePickerArrows>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { formatInternalDate, parseInternalDate } from '~/utils/time_utils';
import AppDatePickerArrows from '~/components/AppDatePickerArrows.vue';

export default {
  name: 'ReportAdvancedDateFilter',
  components: { AppDatePickerArrows },
  props: {
    dateLimit: {
      type: Number,
    },
  },
  computed: {
    ...mapGetters(['reportQuery', 'minDate', 'startWeekOn', 'currentZone']),
    startDate() {
      const date = this.reportQuery.date;

      return date ? TimeUtils.parse_internal_date(date) : null;
    },
    endDate() {
      const date = this.reportQuery.date_end;

      return date ? TimeUtils.parse_internal_date(date) : null;
    },
    date: {
      get() {
        return this.startDate;
      },
      set(dateOrDates) {
        const [start, end] = [].concat(dateOrDates);
        const date = TimeUtils.parse_internal_date(start);
        const startDay = toMomentIsoWeekday(this.startWeekOn);
        const startDate = TimeUtils.format_internal_date(end ? start : date.startOfIsoWeek(startDay));
        const endDate = TimeUtils.format_internal_date(end || date.endOfIsoWeek(startDay));

        this.updateSearch({
          date: startDate,
          date_end: endDate,
        });
      },
    },
    excludeBiweeklyRange() {
      if (this.dateLimit && this.dateLimit < 14) {
        return true;
      }

      return false;
    },
    excludeMonthlyRanges() {
      if (this.dateLimit && this.dateLimit < 28) {
        return true;
      }

      return false;
    },
  },
  methods: {
    ...mapActions(['updateSearch']),
    onChange({ start, end }) {
      const parsedStart = parseInternalDate(start);
      const parsedEnd = parseInternalDate(end);

      this.updateSearch({
        date: formatInternalDate(parsedStart),
        date_end: formatInternalDate(parsedEnd),
      });
    },
  },
};
</script>
